import { atom } from "jotai";

import { selectedRoundAtom } from "../../stores";

export const setTransportationIdTypeOnRoundAtom = atom(
  null,
  (
    get,
    set,
    payload: {
      transportationTypeId: string;
    }
  ) => {
    const selectedRound = get(selectedRoundAtom);
    if (!selectedRound) {
      return;
    }

    set(selectedRoundAtom, {
      ...selectedRound,
      transportationTypeId: payload.transportationTypeId,
    });
  }
);
